import React, { useEffect, useState } from 'react'

import {
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { Box } from '@mui/system'
import { tsMenuItem } from '../Typescript/UI_Interfaces'
import { appBar, drawer } from '../garvan-react/Constants/StyleConstants'
import DrawerMenuItem from './DrawerMenuItem'
import { ArrowBack } from '@mui/icons-material'

export interface tsDrawerItems {
  currentItems: tsMenuItem[]
  parentItems?: tsMenuItem[]
}
function DrawerConfig({ itemsInit }: { itemsInit: tsMenuItem[] }) {
  const [items, setItems] = useState<tsDrawerItems>({
    currentItems: [],
  })

  useEffect(() => {
    setItems({
      currentItems: itemsInit,
    })
  }, [itemsInit])
  return (
    <Drawer
      open={true}
      variant="permanent"
      anchor="left"
    >
      <Box
        sx={{
          mt: appBar / 10,
          width: drawer,
        }}
      >
        {items?.parentItems && (
          <>
            <ListItemButton
              onClick={() => {
                setItems((i: any) => {
                  return { currentItems: i.parentItems }
                })
              }}
            >
              <ListItemIcon>
                <ArrowBack />
              </ListItemIcon>
              <ListItemText primary={'Back in Menu'} />
            </ListItemButton>
            <Divider />
          </>
        )}
        <List>
          {(items?.currentItems ?? []).map((item) => (
            <DrawerMenuItem
              key={item.path}
              setItems={setItems}
              current={item}
            />
          ))}
        </List>
      </Box>
    </Drawer>
  )
}

export default DrawerConfig
